import React, { Component } from 'react';
import i18n from '../i18n';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/styles';
import withWidth from '@material-ui/core/withWidth';
import { withTranslation } from 'react-i18next';
import ControllersActions from '../redux/ControllersRedux';
import SitesActions from '../redux/SitesRedux';
import Header from '../components/header/Header';
import { Colors, StyledComponents, Metrics } from '../themes';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Table from '../components/common/Table';
import ControllerDetails from '../components/controllersElements/ControllerDetails';
import SelectSitesModal from '../components/homeWidgets/SelectSitesModal';
import EditSettingsModal from '../components/controllersElements/EditSettingsModal';
import ChangeCustomerModal from '../components/controllersElements/ChangeCustomerModal';
import clsx from 'clsx';
import cloneDeep from 'lodash/cloneDeep';
import AlertDialog from '../components/common/AlertDialog';
import SnackbarNotification from '../components/common/SnackbarNotification';
import Modal from '../components/common/Modal';
import Dropzone from '../components/controllersElements/Dropzone';
import { haveSameIds, checkRole } from '../lib/Utils';
import {
  controllerReaderBitCount,
  controllerReaderDirection,
  controllerReaderReadType,
  controllerReaderRevert,
} from '../config/AppConfig';
import Immutable from 'seamless-immutable';

const { ControllersMainContentContainer } = StyledComponents;

const styles = (theme) => ({
  gridContainer: {
    [theme.breakpoints.up('xl')]: {
      maxWidth: Metrics.contentGridMaxWidthXl.general,
    },
  },
  paper: {
    textAlign: 'center',
    background: Colors.hoverGrey,
    color: Colors.white,
  },
  listWidget: {},
  detailsWidget: {
    maxWidth: 975,
  },
});

class Controllers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // snackbar
      isSnackbarNotificationOpen: false,
      snackbarVariant: 'warning',
      snackbarMessage: '',
      // alert confirm dialog
      isAlertDialogOpen: false,
      alertTitle: '',
      alertContentText: '',
      alertItemsList: null,
      alertConfirmAction: null,
      alertConfirmButtonString: 'Global_delete',
      alertOKOnly: false,
      //checkboxes
      checkedControllers: [],
      isSelectAllControllersButtonChecked: false,
      //controllers page params
      controllersItemsPerPage: 10,
      controllersPageNumber: 0,
      controllersSearchValue: null,
      controllersSortBy: 'controllerUid',
      controllersSortDirection: 'ASC',
      // controller details
      includeDeletedControllers: false,
      hideDetails: true,
      controllerId: null,
      controllerUid: '',
      controllerName: '',
      controllerStatusId: '',
      customerName: '',
      distributorId: null,
      customerId: null,
      siteName: '',
      siteId: null,
      isOnline: undefined,
      // validation
      isUntouched: true,
      // update controllers
      isUpdateDropZoneOpen: false,
      isFileValid: false,
      // customer modal
      isChangeCustomerModalOpen: false,
      // sites modal
      sites: [],
      selectedSites: [],
      isChangeSiteModalOpen: false,
      sitesItemsPerPage: 10,
      sitesPageNumber: 0,
      sitesSearchValue: null,
      showMaxSitesError: false,
      showSpinner: true,
      // controller settings:
      isEditSettingsModalOpen: false,
      readerDirection: null,
      readerBitCount: null,
      readerReadType: null,
      readerRevert: null,
    };
  }

  componentDidMount() {
    this.sendGetControllersRequest();
  }

  componentWillUnmount() {
    this.props.resetControllers();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.customerId !== this.props.customerId) {
      this.props.resetControllers();
      this.resetControllerFormFields();
      if (this.props.customerId) {
        this.sendGetControllersRequest();
      }
    }
    if (prevProps.isLoading && !this.props.isLoading) {
      if (this.props.successMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'success',
          snackbarMessage: this.props.successMessage,
        });
        if (this.props.lastRequest === 'UPLOAD_FILE_REQUEST') {
          this.setState({
            isUpdateDropZoneOpen: false,
            isAlertDialogOpen: true,
            alertTitle: i18n.t('alert.fileUploadSuccess'),
            alertContentText: i18n.t('alert.instructionsAfterFileUpload'),
            alertConfirmAction: () => this.setState({ isAlertDialogOpen: false }),
            alertOKOnly: true,
          });
        }
      }
      if (this.props.errorMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: this.props.errorMessage,
        });
      }
    }
    if (prevState.includeDeletedControllers !== this.state.includeDeletedControllers) {
      this.sendGetControllersRequest();
    }
    // controllers checkbox select all
    if (!prevState.isSelectAllControllersButtonChecked && this.state.isSelectAllControllersButtonChecked) {
      this.setState({ checkedControllers: this.props.controllers });
    }
    if (
      prevState.isSelectAllControllersButtonChecked &&
      !this.state.isSelectAllControllersButtonChecked &&
      haveSameIds(this.props.controllers, this.state.checkedControllers, 'controllerId')
    ) {
      this.setState({ checkedControllers: [] });
    }
    if (prevState.checkedControllers !== this.state.checkedControllers) {
      this.setState({
        isSelectAllControllersButtonChecked: haveSameIds(
          this.props.controllers,
          this.state.checkedControllers,
          'controllerId'
        ),
      });
    }
    if (
      this.state.customerId &&
      !this.props.sitesIsLoading &&
      prevProps.sitesIsLoading &&
      this.props.sites.length > 0
    ) {
      const selectedSites = this.props.sites.filter((site) => site.siteId === this.state.siteId);
      this.setState({ selectedSites });
    }
    if (prevProps.sites !== this.props.sites && this.props.sites.length === 0) {
      this.setState({ selectedSites: [] });
    }
    if (this.props.controllerDetails !== prevProps.controllerDetails) {
      this.initializeEditSettings();
    }
  }

  // controller edit settings methods

  initializeEditSettings = () => {
    const readerDirection = this.props.controllerDetails?.controllerSettings?.find(
      (setting) => setting?.property === 'readerDirection'
    )?.value;
    const readerReadType = this.props.controllerDetails?.controllerSettings?.find(
      (setting) => setting?.property === 'readerReadType'
    )?.value;
    const readerBitCount = this.props.controllerDetails?.controllerSettings?.find(
      (setting) => setting?.property === 'readerBitcount'
    )?.value;
    const readerRevert = this.props.controllerDetails?.controllerSettings?.find(
      (setting) => setting?.property === 'readerRevert'
    )?.value;
    const isOnline = this.props.controllerDetails?.isOnline;
    this.setState({ readerDirection, readerBitCount, readerReadType, readerRevert, isOnline });
  };

  cancelEditSettings = () => {
    this.setState({ isEditSettingsModalOpen: false });
    this.initializeEditSettings();
  };

  handleSaveControllerSettings = () => {
    const { controllerId, readerDirection, readerBitCount, readerReadType, readerRevert } = this.state;
    const controllerSettings = {
      readerDirection,
      readerBitcount: readerBitCount,
      readerReadType,
      readerRevert,
    };
    this.props.editControllerSettings(controllerId, controllerSettings);
    this.setState({ isEditSettingsModalOpen: false });
  };

  //common methods

  handleChangeFormValues = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  // controllers list table methods

  generateControllerPageParams = () => {
    const sortProperties = [
      {
        name: 'controllerUid',
        sortName: 'controller.controllerUid',
      },
      { name: 'controllerName', sortName: 'controller.name' },
    ];
    const sortBy = sortProperties.find((column) => column.name === this.state.controllersSortBy)?.sortName;
    return {
      items: this.state.controllersItemsPerPage,
      page: this.state.controllersPageNumber,
      ...(this.state.controllersSearchValue && { value: this.state.controllersSearchValue }),
      sortBy,
      sortDirection: this.state.controllersSortDirection,
      ind: this.state.includeDeletedControllers,
    };
  };

  sendGetControllersRequest() {
    this.props.getControllers(this.generateControllerPageParams());
  }

  changeControllersItemsPerPage = (controllersItemsPerPage) => {
    this.setState({ controllersItemsPerPage, controllersPageNumber: 0 }, () => this.sendGetControllersRequest());
  };

  changeControllersPage = (controllersPageNumber) => {
    this.setState({ controllersPageNumber }, () => this.sendGetControllersRequest());
  };

  handleSearchController = (controllersSearchValue) => {
    this.setState({ controllersSearchValue, controllersPageNumber: 0 }, () => this.sendGetControllersRequest());
    this.resetControllerFormFields();
  };

  handleSortController = (controllersSortBy, controllersSortDirection) => {
    this.setState({ controllersSortBy, controllersSortDirection, controllersPageNumber: 0 }, () =>
      this.sendGetControllersRequest()
    );
    this.resetControllerFormFields();
  };

  handleSearchControllerKeyPress = (event, value) => {
    if (event.key === 'Enter') {
      this.handleSearchController(value);
    }
  };

  selectController = (selectedController) => {
    this.resetControllerFormFields();
    this.props.getControllerDetails(selectedController?.controllerId);
    const {
      controllerId,
      controllerName,
      controllerStatusId,
      controllerUid,
      distributorId,
      customerId,
      customerName,
      siteName,
      siteId,
    } = selectedController;
    this.setState({
      hideDetails: false,
      controllerId,
      controllerName,
      controllerStatusId,
      controllerUid,
      distributorId,
      customerId,
      customerName,
      siteName,
      siteId,
    });
    const isCustomerAdmin = checkRole(this.props.role, 'customerAdmin');
    !isCustomerAdmin && this.props.getCustomersForController(distributorId);
  };

  // checkboxes
  handleCheckController = (controller) => {
    const previousControllers = this.state.checkedControllers;
    //check if the controller was present in checkedControllers
    const selectedIndex = previousControllers.findIndex((item) => item.controllerId === controller.controllerId);
    let newCheckedControllers = [];

    if (selectedIndex === -1) {
      // if not found, add it
      newCheckedControllers = newCheckedControllers.concat(previousControllers, controller);
    } else if (selectedIndex === 0) {
      // if first item, remove it
      newCheckedControllers = newCheckedControllers.concat(previousControllers.slice(1));
    } else if (selectedIndex === previousControllers.length - 1) {
      // if last item, remove it
      newCheckedControllers = newCheckedControllers.concat(previousControllers.slice(0, -1));
    } else if (selectedIndex > 0) {
      // if between first and last, remove it
      newCheckedControllers = newCheckedControllers.concat(
        previousControllers.slice(0, selectedIndex),
        previousControllers.slice(selectedIndex + 1)
      );
    }
    this.setState({ checkedControllers: newCheckedControllers });
  };

  // Controller details form methods

  resetControllerFormFields = () => {
    this.setState({
      controllerId: null,
      controllerName: '',
      controllerStatusId: '',
      controllerUid: '',
      distributorId: null,
      customerId: null,
      customerName: '',
      siteName: '',
      siteId: null,
      isOnline: undefined,
    });
  };

  handleSaveController = () => {
    const { controllerId, controllerName, customerId, siteId } = this.state;
    const controllerInfos = {
      controllerName,
      customerId,
      siteId,
    };
    this.props.editController(controllerId, controllerInfos, this.generateControllerPageParams());
  };

  applyControllersUpdate = () => {
    const isCheckedControllers = !!this.state.checkedControllers.length;
    const controllersList = this.state.checkedControllers.map(({ controllerUid, controllerName }) => (
      <li key={controllerUid}>
        {controllerUid} {controllerName}
      </li>
    ));
    this.setState({
      isAlertDialogOpen: true,
      alertTitle: i18n.t(isCheckedControllers ? 'alert.updateControllersTitle' : 'alert.selectControllersTitle'),
      alertContentText: i18n.t(
        isCheckedControllers ? 'alert.updateControllersConfirmText' : 'alert.selectAtLeastOneControllerText'
      ),
      alertItemsList: controllersList,
      alertConfirmAction: isCheckedControllers
        ? this.updateSoftware
        : () => this.setState({ isAlertDialogOpen: false }),
      alertConfirmButtonString: i18n.t('controllerManager_updateController'),
      alertOKOnly: !isCheckedControllers,
    });
  };

  updateSoftware = () => {
    this.setState({ isAlertDialogOpen: false });
    const body = {
      controllers: this.state.checkedControllers.map(({ controllerId }) => controllerId),
      fileName: this.props.fileName,
    };
    this.props.updateControllers(body);
  };

  openDeleteControllerAlert = () => {
    const { controllerName, controllerUid } = this.state;
    this.setState({
      isAlertDialogOpen: true,
      alertTitle: i18n.t('alert.deleteControllerTitle'),
      alertContentText: i18n.t('controllerManager_confirmDeleteController', { controllerName, controllerUid }),
      alertItemsList: null,
      alertConfirmAction: this.deleteController,
      alertConfirmButtonString: 'Global_delete',
      alertOKOnly: false,
    });
  };

  deleteController = () => {
    this.props.deleteController(this.state.controllerId, this.generateControllerPageParams());
    this.resetControllerFormFields();
    this.setState({ isAlertDialogOpen: false, hideDetails: true });
  };

  handleControllerDetailsFormKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (!this.state.controllersSearchValue) {
        return this.handleSaveController();
      }
    }
  };

  openChangeSiteModal = () => {
    this.setState({ isChangeSiteModalOpen: true });
    this.sendGetSitesRequest();
  };

  sendGetSitesRequest = () => {
    const pageParams = {
      items: this.state.sitesItemsPerPage,
      page: this.state.sitesPageNumber,
      value: this.state.sitesSearchValue,
    };
    this.props.getSites(this.state.customerId, pageParams);
  };

  // Sites Modal methods
  changeSitesItemsPerPage = (sitesItemsPerPage) => {
    this.setState({ sitesItemsPerPage, sitesPageNumber: 0 }, () => this.sendGetSitesRequest());
  };

  changeSitesPage = (sitesPageNumber) => {
    this.setState({ sitesPageNumber }, () => this.sendGetSitesRequest());
  };

  handleSearchSites = (sitesSearchValue) => {
    this.setState({ sitesSearchValue, sitesPageNumber: 0 }, () => this.sendGetSitesRequest());
  };

  handleSearchSitesKeyPress = (event, value) => {
    if (event.key === 'Enter') {
      this.handleSearchSites(value);
    }
  };

  selectSite = (site) => {
    this.setState({
      siteId: site?.siteId,
      selectedSites: [site],
      siteName: site?.address?.fullName,
    });
  };

  render() {
    const sitesData = cloneDeep(this.props.sites).map((site) => ({ name: site.address.fullName, ...site }));
    const { t, classes, width } = this.props;
    const isLarge = width === 'lg' || width === 'xl';
    const controllersData = cloneDeep(this.props.controllers); //this is necessary for table to work
    const isSystemAdmin = checkRole(this.props.role, 'systemAdmin');
    const isDistributorAdmin = checkRole(this.props.role, 'distributorAdmin');
    return (
      <ControllersMainContentContainer className={classes.MainContentContainer}>
        <AlertDialog
          open={this.state.isAlertDialogOpen}
          handleClose={() => this.setState({ isAlertDialogOpen: false })}
          title={this.state.alertTitle}
          contentText={this.state.alertContentText}
          itemsList={this.state.alertItemsList}
          cancelButtonText={t('Global_cancel')}
          confirmButtonText={t(this.state.alertConfirmButtonString)}
          onConfirm={this.state.alertConfirmAction}
          isOKOnly={this.state.alertOKOnly}
          rightButtonBlue={this.state.alertOKOnly}
        />
        <SnackbarNotification
          variant={this.state.snackbarVariant}
          open={this.state.isSnackbarNotificationOpen}
          message={this.state.snackbarMessage}
          close={() => this.setState({ isSnackbarNotificationOpen: false })}
        />
        <Modal
          open={this.state.isUpdateDropZoneOpen}
          handleClose={() => this.setState({ isUpdateDropZoneOpen: false })}
          Content={Dropzone}
          isFileValid={this.state.isFileValid}
          setFileValid={(val) => this.setState({ isFileValid: val })}
          uploadFile={(file) => this.props.uploadFile(file)}
          isUploading={this.props.isLoading && this.props.lastRequest === 'UPLOAD_FILE_REQUEST'}
        />
        {/* edit customer modal */}
        {(isSystemAdmin || isDistributorAdmin) && (
          <Modal
            isSystemAdmin={isSystemAdmin}
            isDistributorAdmin={isDistributorAdmin}
            open={this.state.isChangeCustomerModalOpen}
            handleClose={() => this.setState({ isChangeCustomerModalOpen: false })}
            Content={ChangeCustomerModal}
            title={t('controllers.changeCustomer')}
            // common
            lightTheme
            formStyle
            selectWidth={225}
            distributorId={this.state.distributorId}
            distributorInfo={this.props.distributorInfo}
            customerId={this.state.customerId}
            customerIdSub={this.props.customerIdSub}
            distributors={this.props.distributors}
            customers={this.props.customers}
            getCustomersForController={(distributorId) => this.props.getCustomersForController(distributorId)}
            selectDistributor={(distributorId, distributorName) => this.setState({ distributorId, distributorName })}
            selectCustomer={(customerId, customerName) => this.setState({ customerId, customerName })}
          />
        )}
        <Modal
          open={this.state.isChangeSiteModalOpen}
          handleClose={() => this.setState({ isChangeSiteModalOpen: false })}
          Content={SelectSitesModal}
          title={t('controllers.changeSite')}
          lightTheme
          hideSaveButtons
          checkboxColumn="start"
          data={sitesData}
          showMaxSitesError={this.state.showMaxSitesError}
          maxSitesNumber={1}
          noDataText={t('controllerManager_noSite')}
          handleClick={(site) => this.selectSite(site)}
          columns={[{ title: t('common.name'), field: 'name', id: 'name' }]}
          handleSearch={this.handleSearchSites}
          activeRowField={'siteId'}
          checkedArray={this.state.selectedSites}
          searchPlaceholder={t('sites.searchSite')}
          itemsPerPage={this.state.sitesItemsPerPage}
          changeItemsPerPage={this.changeSitesItemsPerPage}
          totalElements={this.props.sitesTotalElements}
          page={this.state.sitesPageNumber}
          changePage={this.changeSitesPage}
          onKeyPress={this.handleSearchSitesKeyPress}
          // rows per page select props
          selectData={[5, 10, 20]}
          selectLabel={t('table.showPerPage')}
          selectValue={this.state.sitesItemsPerPage}
          onSelect={this.changeSitesItemsPerPage}
          selectWidth={90}
        />
        <Header
          selectControllersUpdate={() => {
            this.setState({ isUpdateDropZoneOpen: true, isFileValid: true });
            this.props.resetFile();
          }}
          isFileUploaded={!!this.props.fileName}
          applyControllersUpdate={this.applyControllersUpdate}
        />
        <Grid container className={classes.gridContainer} spacing={isLarge ? 6 : 5}>
          <Grid item xs={12} md={6} xl={5}>
            <Paper className={clsx(classes.paper, classes.listWidget)}>
              <Table
                checkboxColumn="start"
                checkedArray={this.state.checkedControllers}
                isThreeElementsHeader
                isSelectAll
                data={controllersData}
                noDataText={t('controllers.noControllers')}
                handleCheck={(controller) => this.handleCheckController(controller)}
                handleClick={(selectedController) => this.selectController(selectedController)}
                columns={[
                  { title: t('controllerManager_searchControllers_col1'), field: 'controllerUid', id: 'controllerUid' },
                  {
                    title: t('controllerManager_searchControllers_col2'),
                    field: 'controllerName',
                    id: 'controllerName',
                  },
                  { title: t('controllerManager_searchControllers_col3'), field: 'customerName', id: 'customerName' },
                ]}
                activeRowValue={this.state.controllerId}
                activeRowField={'controllerId'}
                handleSearch={this.handleSearchController}
                sortBy={this.state.controllersSortBy}
                sortDirection={this.state.controllersSortDirection}
                handleSort={this.handleSortController}
                searchPlaceholder={t('table.search')}
                itemsPerPage={this.state.controllersItemsPerPage}
                changeItemsPerPage={this.changeControllersItemsPerPage}
                totalElements={this.props.controllersTotalElements}
                page={this.state.controllersPageNumber}
                changePage={this.changeControllersPage}
                onKeyPress={this.handleSearchControllerKeyPress}
                // rows per page select props
                selectData={[5, 10, 20, 50, 100]}
                selectLabel={t('table.showPerPage')}
                selectValue={this.state.controllersItemsPerPage}
                onSelect={this.changeControllersItemsPerPage}
                selectWidth={90}
                includeDeletedControllers={this.state.includeDeletedControllers}
                onChangeIncludeDeletedController={(event) =>
                  this.setState({ includeDeletedControllers: event.target.checked })
                }
                isSelectAllControllersButtonChecked={this.state.isSelectAllControllersButtonChecked}
                changeSelectAllControllersButton={() =>
                  this.setState((prevState) => ({
                    isSelectAllControllersButtonChecked: !prevState.isSelectAllControllersButtonChecked,
                  }))
                }
              />
            </Paper>
          </Grid>
          <Modal
            open={this.state.isEditSettingsModalOpen}
            handleClose={() => this.setState({ isEditSettingsModalOpen: false })}
            Content={EditSettingsModal}
            // readerDirection
            readerDirectionSelectData={controllerReaderDirection}
            readerDirectionSelectLabel={'Reader direction'}
            readerDirectionSelectValue={this.state.readerDirection}
            readerDirectionOnSelect={(readerDirection) => this.setState({ readerDirection })}
            // readerBitCount
            readerBitCountSelectData={controllerReaderBitCount}
            readerBitCountSelectLabel={'Reader bit count'}
            readerBitCountSelectValue={this.state.readerBitCount}
            readerBitCountOnSelect={(readerBitCount) => this.setState({ readerBitCount })}
            // readerReadType
            readerReadTypeSelectData={controllerReaderReadType}
            readerReadTypeSelectLabel={'Reader read type'}
            readerReadTypeSelectValue={this.state.readerReadType}
            readerReadTypeOnSelect={(readerReadType) => this.setState({ readerReadType })}
            // readerRevert
            readerRevertSelectData={controllerReaderRevert}
            readerRevertSelectLabel={'Revert byte order'}
            readerRevertSelectValue={this.state.readerRevert}
            readerRevertOnSelect={(readerRevert) => this.setState({ readerRevert })}
            lightTheme
            selectWidth={225}
            cancelEditSettings={this.cancelEditSettings}
            onClickSave={this.handleSaveControllerSettings}
          />
          <Grid item xs={12} md={6} xl={7}>
            <Paper className={clsx(classes.paper, classes.detailsWidget)}>
              <ControllerDetails
                controllerId={this.state.controllerId}
                openChangeCustomerModal={() => this.setState({ isChangeCustomerModalOpen: true })}
                openChangeSiteModal={this.openChangeSiteModal}
                //buttons
                isDeleted={this.state.controllerStatusId === -1}
                onDeleteButtonClick={this.openDeleteControllerAlert}
                onSaveButtonClick={this.handleSaveController}
                isDeleteButtonDisabled={!this.state.controllerId}
                saveButtonDisabled={!this.state.controllerId}
                // controller details form
                onKeyPressFormSubmit={this.handleControllerDetaisFormKeyPress}
                onChange={this.handleChangeFormValues}
                hideDetails={!this.state.controllerId}
                controllerUid={this.state.controllerUid}
                controllerName={this.state.controllerName}
                customerName={this.state.customerName}
                siteName={this.state.siteName}
                isOnline={this.state.isOnline}
                // form and validations
                isUntouched={this.state.isUntouched}
                setUntouched={(value) => this.setState({ isUntouched: value })}
                controllerStatus={
                  this.props.controllerDetails
                    ? Immutable.asMutable(this.props.controllerDetails?.controllerStatus).sort((a, b) =>
                        a.property.localeCompare(b.property)
                      )
                    : null
                }
                controllerSettings={
                  this.props.controllerDetails
                    ? Immutable.asMutable(this.props.controllerDetails?.controllerSettings).sort((a, b) =>
                        a.property.localeCompare(b.property)
                      )
                    : null
                }
                // Tables
                handleTabClick={() => this.setState({ isEditSettingsModalOpen: true })}
              />
            </Paper>
          </Grid>
        </Grid>
      </ControllersMainContentContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //controllers
    isLoading: state.controllers.isLoading,
    successMessage: state.controllers.successMessage,
    errorMessage: state.controllers.errorMessage,
    controllers: state.controllers.controllers,
    controllersTotalElements: state.controllers.totalElements,
    lastRequest: state.controllers.lastRequest,
    fileName: state.controllers.fileName,
    controllerDetails: state.controllers.controllerDetails,
    //distributor && customer
    role: state.auth.role,
    distributorId: state.auth.distributorId,
    distributorIdSub: state.auth.distributorIdSub,
    customerId: state.auth.customerId,
    customerIdSub: state.auth.customerIdSub,
    distributorInfo: state.distributors.distributorInfo,
    distributors: state.distributors.distributors,
    customers: state.controllers.customers,
    //sites
    sites: state.sites.sites,
    sitesIsLoading: state.sites.isLoading,
    sitesTotalElements: state.sites.totalElements,
  };
};

const mapDispatchToProps = (dispatch) => ({
  //controllers
  getControllers: (pageParams) => dispatch(ControllersActions.getControllersRequest(pageParams)),
  getControllerDetails: (controllerId) => dispatch(ControllersActions.getControllerDetailsRequest(controllerId)),
  editController: (controllerId, controllerInfos, pageParams) =>
    dispatch(ControllersActions.editControllerRequest(controllerId, controllerInfos, pageParams)),
  editControllerSettings: (controllerId, controllerSettings) =>
    dispatch(ControllersActions.editControllerSettingsRequest(controllerId, controllerSettings)),
  deleteController: (controllerId, pageParams) =>
    dispatch(ControllersActions.deleteControllerRequest(controllerId, pageParams)),
  resetControllers: () => dispatch(ControllersActions.resetControllers()),
  uploadFile: (file) => dispatch(ControllersActions.uploadFileRequest(file)),
  updateControllers: (body) => dispatch(ControllersActions.updateControllersRequest(body)),
  resetFile: () => dispatch(ControllersActions.resetFile()),
  // customers
  getCustomersForController: (distributorId) =>
    dispatch(ControllersActions.getCustomersForControllerRequest(distributorId)),
  // sites
  getSites: (customerId, pageParams) => dispatch(SitesActions.getSitesRequest(customerId, pageParams)),
});

export default compose(
  withTranslation(),
  withStyles(styles),
  withWidth(),
  connect(mapStateToProps, mapDispatchToProps)
)(Controllers);
